import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import LeftComponent from 'components/Authorization/LeftComponent';
import SignUpForm from 'components/Authorization/SignUp/SignUpForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator.js';
import moment from 'moment';

const {
  createUser,
  cleanErrors,
  addValidateError,
} = actions;

const {
  ERROR_TYPE_USER_CREATE_ERROR
} = constants;

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        email_confirmation: '',
        user_type: null,
        registration: '',
        imc: '',
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone

      },
      termsOfService: false
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  validateUser = () => {
    this.props.validateUser(
      validator.validate(this.state.user, 'user')
    )
  }

  onFieldChange = (e) => {
    const userData = { ...this.state.user,
      ...{
        [e.target.name]: e.target.value
      }
    }

    this.setState({ user: userData })//, this.validateUser); on input change validation
  }

  onTermsOfServiceChange = (status) => {
    this.setState({
      termsOfService: status
    })
  }

  onCreateSubmit = (e) => {
    e.preventDefault();
    if (!this.state.termsOfService) {
      toast.warning('Terms of service must be accepted')
      return;
    }
    this.props.createUser(this.state.user);
  }

  roleFields = () => {
    switch (this.state.user.user_type) {
      case 'gp':
        return ['imc']
      case 'gp_trainee':
        return ['imc']
      case 'consultant':
        return ['imc']
      case 'hospital_doctor':
        return ['imc']
      case 'practice_nurse':
        return ['registration']
      case 'nurse_specialist':
        return ['registration']
      default: return []
    }
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;

    const outErrors = Object.keys(errorsFrontend || {}).length ? errorsFrontend : errors;
    return (
      <main className="">
        <div className="container_content_password">
          <LeftComponent />
          <SignUpForm
            user={this.state.user}
            onFieldChange={this.onFieldChange}
            onSubmit={this.onCreateSubmit}
            errors={outErrors}
            onTermsOfServiceChange={this.onTermsOfServiceChange}
            termsOfService={this.state.termsOfService}
            roleFields={this.roleFields()}
          />
        </div>
      </main>
    )
  }
}

const mapStateToProps = (state) => ({
  errors: state['errors'][ERROR_TYPE_USER_CREATE_ERROR],
  errorsFrontend: state['errors'][`${ERROR_TYPE_USER_CREATE_ERROR}_FRONTEND`]
})

const mapDispatchToProps = (dispatch) => ({
   validateUser: (errors) => dispatch(addValidateError(ERROR_TYPE_USER_CREATE_ERROR, errors)),
   createUser: (user) => dispatch(createUser(user)),
   cleanErrors: () => dispatch(cleanErrors(ERROR_TYPE_USER_CREATE_ERROR)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



/** WEBPACK FOOTER **
 ** ./src/containers/Authorization/SignUp/SignUp.js
 **/